module.exports = __webpack_public_path__ + "static/media/RU.4336677b.svg";